module.exports = __webpack_public_path__ + "static/media/fire.ae0aa004.png";